"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gen_addCreatures = void 0;
var crokinoleUi_menu_players_1 = require("@crokinole/ui-menus/crokinoleUi_menu_players");
var randoInstanced_1 = require("@dive/to-engine/randoInstanced");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var minigolfCamera_sidecar_1 = require("../camera/minigolfCamera-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
var minigolfBoundaries_sidecar_1 = require("../entities/minigolfBoundaries-sidecar");
var minigolfCreatures_sidecar_1 = require("../entities/minigolfCreatures-sidecar");
var minigolfCreaturesData_sidecar_1 = require("../entities/minigolfCreaturesData-sidecar");
var minigolfGameState_sidecar_1 = require("../simulation/minigolfGameState-sidecar");
var minigolfMainGameGenerator_sidecar_1 = require("../simulation/minigolfMainGameGenerator-sidecar");
var battlescapeMap_sidecar_1 = require("./battlescapeMap-sidecar");
function gen_addCreatures(m, rando) {
    var allowExperimental, playerState, isEasy, isNormal, isHard, datas, trapsList, dungeonLevelAdjustFactor, dungeonLevelAdjusted, levelTrapType, lockedChance, enemyDifficultyMultiplier, bonusDifficultyMultiplier, numEnemyPoints, numBonuses, isWinLevel, puckSpawnerTiles, borderTiles, borderTilesH, borderTilesV, blockTiles, holeSpawnerTiles, bonusSpawnerTiles, triangleSpawnerTiles, trapSpawnerTiles, slopeSpawnerTiles, slope2SpawnerTiles, highgroundSpawnerTiles, possibleWallSpawnerTiles, doResetTiles, sections, enableHorizSpans, enableVerticalSpans, iy, spanStartX, spanCount, spanStarted, ix, tile, i, tile2, offset, ix, spanStartY, spanCount, spanStarted, iy, tile, i, tile2, offset, iSection, section, iTile, tile, creaturesList, createPuckAtTile, createBorderAtTile, createCrateAtTile, needsAmulet, createNextLevelStairsAtTile, createAtTile, createEnemyAtTile, createTriangleAtTile, bonuses, createBonusAtTile, puckSpawner, i, holeSpawner, creat, holeSpawner, bonusSpawner, cc, idxBorder, borderSpawner, idxBorderH, borderSpawner, idxBorderV, borderSpawner, idxBlock, blockSpawner, idxTriangle, triangleSpawner, idxSpawner, spawner, cc, idxSpawner, spawner, cc, creature, rot, idxSpawner, spawner, cc, creature, rot, idxSpawner, spawner, cc, bonusSpawner, idxEnemy, bonusSpawner, enemy, idxBonus, bonusSpawner;
    return __generator(this, function (_a) {
        minigolfBoundaries_sidecar_1.minigolfBoundaries.killAll();
        minigolfBoundaries_sidecar_1.minigolfBoundaries.createBasic();
        allowExperimental = true // window.location.href.includes('//localhost:8082')
        ;
        playerState = minigolfGameState_sidecar_1.minigolfGameState.get().playerState;
        isEasy = playerState.difficulty === 'easy';
        isNormal = playerState.difficulty === 'normal';
        isHard = playerState.difficulty === 'hard';
        datas = minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData;
        trapsList = [datas.lava, datas.spikeSquare, datas.slimePool];
        dungeonLevelAdjustFactor = 0;
        if (isEasy) {
            dungeonLevelAdjustFactor -= 3;
        }
        if (isHard) {
            dungeonLevelAdjustFactor += 3;
        }
        dungeonLevelAdjusted = playerState.dungeonLevel + dungeonLevelAdjustFactor;
        if (minigolfDefs_sidecar_1.minigolfDefs.debug_trapType) {
            trapsList = trapsList.filter(function (c) { return c.creatureType === minigolfDefs_sidecar_1.minigolfDefs.debug_trapType; });
        }
        else {
            trapsList = trapsList.filter(function (c) { return c.enemyDifficulty <= dungeonLevelAdjusted; });
        }
        if (trapsList.length === 0) {
            trapsList = [datas.slimePool];
        }
        levelTrapType = rando.sample(trapsList);
        // Level special effects
        // playerState.levelPar = 3 // Already set by level gen
        playerState.isDungeonBroken = false || minigolfDefs_sidecar_1.minigolfDefs.debug_testBrokenLevel;
        playerState.isDungeonLocked = false || minigolfDefs_sidecar_1.minigolfDefs.debug_testLockedLevel;
        lockedChance = 1 / 5;
        if (isEasy) {
            lockedChance = 1 / 8;
        }
        if (isHard) {
            lockedChance = 1 / 3;
        }
        if (dungeonLevelAdjusted >= 5) {
            if (rando.chance(1 / 5)) {
                playerState.isDungeonBroken = true; // TODO: extra par?
                playerState.levelPar += 1;
            }
        }
        if (dungeonLevelAdjusted >= 3) {
            if (rando.chance(lockedChance)) {
                playerState.isDungeonLocked = true; // TODO: extra par?
                playerState.levelPar += 2;
            }
        }
        enemyDifficultyMultiplier = 1;
        bonusDifficultyMultiplier = 1;
        if (isEasy) {
            enemyDifficultyMultiplier = 0.5;
            bonusDifficultyMultiplier = 1.25;
        }
        if (isHard) {
            enemyDifficultyMultiplier = 1.25;
            bonusDifficultyMultiplier = 0.75;
        }
        numEnemyPoints = Math.floor(playerState.dungeonLevel * 1.5 * enemyDifficultyMultiplier);
        numBonuses = 3 + Math.floor((playerState.dungeonLevel / 3) * bonusDifficultyMultiplier);
        if (playerState.dungeonLevel === 0) {
            numBonuses = 0;
        }
        if (minigolfDefs_sidecar_1.minigolfDefs.debug_noEnemies) {
            numEnemyPoints = 0;
        }
        isWinLevel = playerState.dungeonLevel >= 19;
        if (isWinLevel) {
            numEnemyPoints = 0;
            numBonuses = 15;
        }
        puckSpawnerTiles = [];
        borderTiles = [];
        borderTilesH = [];
        borderTilesV = [];
        blockTiles = [];
        holeSpawnerTiles = [];
        bonusSpawnerTiles = [];
        triangleSpawnerTiles = [];
        trapSpawnerTiles = [];
        slopeSpawnerTiles = [];
        slope2SpawnerTiles = [];
        highgroundSpawnerTiles = [];
        possibleWallSpawnerTiles = [];
        doResetTiles = true;
        sections = m.sections;
        enableHorizSpans = true;
        enableVerticalSpans = true;
        if (!playerState.isDungeonBroken && allowExperimental) {
            if (enableHorizSpans) {
                for (iy = 0; iy < m.totalTileHeight; iy++) {
                    spanStartX = 0;
                    spanCount = 0;
                    spanStarted = false;
                    for (ix = 0; ix < m.totalTileWidth; ix++) {
                        tile = battlescapeMap_sidecar_1.battlescapeMap.getAt(m, ix, iy);
                        assert_sidecar_1.assert.notNil(tile, 'tile not found');
                        if (tile.tileIdx === 3) {
                            if (!spanStarted) {
                                spanStartX = ix;
                                spanStarted = true;
                                spanCount = 1;
                            }
                            else {
                                spanCount++;
                                // tile.tileIdx = 304
                            }
                        }
                        else {
                            // close span
                            if (spanStarted && spanCount >= 2) {
                                for (i = 0; i < spanCount; i++) {
                                    tile2 = battlescapeMap_sidecar_1.battlescapeMap.getAt(m, spanStartX + i, iy);
                                    assert_sidecar_1.assert.notNil(tile2, 'tile2 not found');
                                    tile2.tileIdx = 304;
                                }
                                offset = 0.5;
                                minigolfBoundaries_sidecar_1.minigolfBoundaries.createBoundary(spanStartX - offset, iy - offset, spanStartX + spanCount - offset, iy + offset);
                            }
                            spanCount = 0;
                            spanStarted = false;
                        }
                    }
                }
            }
            if (enableVerticalSpans) {
                for (ix = 0; ix < m.totalTileWidth; ix++) {
                    spanStartY = 0;
                    spanCount = 0;
                    spanStarted = false;
                    for (iy = 0; iy < m.totalTileHeight; iy++) {
                        tile = battlescapeMap_sidecar_1.battlescapeMap.getAt(m, ix, iy);
                        assert_sidecar_1.assert.notNil(tile, 'tile not found');
                        if (tile.tileIdx === 3) {
                            if (!spanStarted) {
                                // console.log('new span v')
                                spanStartY = iy;
                                spanStarted = true;
                                spanCount = 1;
                            }
                            else {
                                spanCount++;
                                // tile.tileIdx = 304
                            }
                        }
                        else {
                            // close span
                            if (spanStarted && spanCount >= 2) {
                                // console.log('close span v')
                                for (i = 0; i < spanCount; i++) {
                                    tile2 = battlescapeMap_sidecar_1.battlescapeMap.getAt(m, ix, spanStartY + i);
                                    assert_sidecar_1.assert.notNil(tile2, 'tile2 not found');
                                    tile2.tileIdx = 305;
                                }
                                offset = 0.5;
                                minigolfBoundaries_sidecar_1.minigolfBoundaries.createBoundary(ix - offset, spanStartY - offset, ix + offset, spanStartY + spanCount - offset);
                            }
                            spanCount = 0;
                            spanStarted = false;
                        }
                    }
                }
            }
            // for (let iSection = 0; iSection < sections.length; iSection++) {
            //   let section = sections[iSection]
            //   for (let iTile = 0; iTile < section.tiles.length; iTile++) {
            //     let tile = section.tiles[iTile]
            //     if (tile.tileIdx === 3) {
            //       tile.tileIdx = 304
            //     }
            //   }
            // }
        }
        for (iSection = 0; iSection < sections.length; iSection++) {
            section = sections[iSection];
            for (iTile = 0; iTile < section.tiles.length; iTile++) {
                tile = section.tiles[iTile];
                if (tile.tileIdx === 56) {
                    // Code for outside tile greenery
                    if (doResetTiles) {
                        tile.tileIdx = -1;
                        if (rando.chance(0.33)) {
                            if (rando.chance(0.5)) {
                                tile.tileIdxUp = 157;
                            }
                            else {
                                tile.tileIdxUp = 158;
                            }
                        }
                    }
                }
                if (tile.tileIdx === 39 || tile.tileIdxUp === 39) {
                    puckSpawnerTiles.push(tile);
                    if (doResetTiles && tile.tileIdx === 39) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 3) {
                    borderTiles.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 304) {
                    borderTilesH.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 305) {
                    borderTilesV.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 12) {
                    blockTiles.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 52 || tile.tileIdxUp === 52) {
                    holeSpawnerTiles.push(tile);
                    if (doResetTiles && tile.tileIdx === 52) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 62 || tile.tileIdxUp === 62) {
                    bonusSpawnerTiles.push(tile);
                    if (doResetTiles && tile.tileIdx === 62) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 4) {
                    triangleSpawnerTiles.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 58) {
                    trapSpawnerTiles.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 109 || tile.tileIdxUp === 109) {
                    possibleWallSpawnerTiles.push(tile);
                    if (doResetTiles && tile.tileIdx === 109) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 22) {
                    slopeSpawnerTiles.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 23) {
                    slope2SpawnerTiles.push(tile);
                    if (doResetTiles) {
                        tile.tileIdx = 0;
                    }
                }
                if (tile.tileIdx === 34) {
                    highgroundSpawnerTiles.push(tile);
                    // if (doResetTiles) {
                    //   tile.tileIdx = 0
                    // }
                }
                if (tile.tileIdx === 101 || tile.tileIdxUp === 101) {
                    // Code for outside tile
                    if (doResetTiles) {
                        tile.tileIdx = -1;
                    }
                }
            }
        }
        if (!isWinLevel) {
            if (holeSpawnerTiles.length === 0) {
                console.log(crokinoleUi_menu_players_1.namespace, 'reset -- needs hole');
                minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                return [2 /*return*/, 0];
            }
        }
        if (puckSpawnerTiles.length === 0) {
            console.log(crokinoleUi_menu_players_1.namespace, 'reset -- needs puck spawner');
            minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
            return [2 /*return*/, 0];
        }
        // Cleanup
        // minigolfPucks.killAll()
        // minigolfBlocks.killAll()
        minigolfCreatures_sidecar_1.minigolfCreatures.killAll();
        creaturesList = [
            datas.enemyBat,
            datas.enemyBlob,
            datas.enemyGhost,
            datas.enemyMimic,
            datas.enemyJelly,
            datas.enemyRat,
            datas.enemyGoblin,
            datas.enemyTroll,
            datas.enemySpider,
            datas.enemyWraith,
        ] // ['bat', 'blob', 'ghost', 'mimic']
        ;
        if (minigolfDefs_sidecar_1.minigolfDefs.debug_enemyType) {
            creaturesList = creaturesList.filter(function (c) { return c.creatureType === minigolfDefs_sidecar_1.minigolfDefs.debug_enemyType; });
        }
        else {
            creaturesList = creaturesList.filter(function (c) { return c.enemyDifficulty <= dungeonLevelAdjusted; });
        }
        createPuckAtTile = function (tx, ty) {
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            // minigolfPucks.create(cc.x, cc.y)
            minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.playerPuck);
        };
        createBorderAtTile = function (tx, ty, isH, isV) {
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            // minigolfBlocks.create(cc.x, cc.y, 50)
            if (rando.chance(0.05)) {
                if (isH) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.blockSquareTorchCombined);
                    return;
                }
                if (isV) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.blockSquareTorchCombined);
                    return;
                }
                minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, playerState.isDungeonBroken
                    ? datas.blockSquareTorchBroken
                    : datas.blockSquareTorch);
            }
            else {
                if (isH) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.blockSquareCombinedH);
                    return;
                }
                if (isV) {
                    minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.blockSquareCombinedV);
                    return;
                }
                minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, playerState.isDungeonBroken
                    ? datas.blockSquareBroken
                    : datas.blockSquare);
            }
        };
        createCrateAtTile = function (tx, ty) {
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            // minigolfBlocks.create(cc.x, cc.y, 10)
            minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.crate);
        };
        needsAmulet = minigolfGameState_sidecar_1.minigolfGameState.get().playerState.dungeonLevel === 18 ||
            minigolfDefs_sidecar_1.minigolfDefs.debug_ezAmulet;
        createNextLevelStairsAtTile = function (tx, ty) {
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            //minigolfHoles.create(cc.x, cc.y, 150)
            var creat = null;
            if (needsAmulet) {
                creat = minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.stairsUp);
            }
            else {
                creat = minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, minigolfCreaturesData_sidecar_1.minigolfCreaturesData.MinigolfCreaturesData.stairsDown);
            }
            if (playerState.isDungeonLocked) {
                createAtTile(tx, ty, playerState.isDungeonBroken ? datas.doorLockedBroken : datas.doorLocked);
            }
            return creat;
        };
        createAtTile = function (tx, ty, data) {
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            return minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, data);
        };
        createEnemyAtTile = function (tx, ty) {
            var creatureType = rando.sample(creaturesList);
            return createAtTile(tx, ty, creatureType);
        };
        createTriangleAtTile = function (tile) {
            //: tx: number, ty: number) => {
            var tx = tile.tx;
            var ty = tile.ty;
            var rot = tile.rotation;
            // console.log('triangle rotation', rot)
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            var creature = minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, playerState.isDungeonBroken
                ? datas.blockTriangleBroken
                : datas.blockTriangle);
            creature.rigidBody.setRotation(-mathUtils_sidecar_1.mathUtils.turn(rot / 4), true);
        };
        bonuses = [];
        randoInstanced_1.addWeighted(bonuses, datas.bonusFood, 7.5);
        randoInstanced_1.addWeighted(bonuses, datas.bonusHealth, 5);
        randoInstanced_1.addWeighted(bonuses, datas.bonusHealth2, 2.5);
        randoInstanced_1.addWeighted(bonuses, datas.bonusSword, 1.5);
        randoInstanced_1.addWeighted(bonuses, datas.crate, 10);
        randoInstanced_1.addWeighted(bonuses, datas.bonusWeb, 2.5);
        randoInstanced_1.addWeighted(bonuses, datas.bonusMoney, 2.5);
        randoInstanced_1.addWeighted(bonuses, playerState.isDungeonBroken ? datas.blockPillarBroken : datas.blockPillar, 5);
        if (isWinLevel) {
            // Just money
            bonuses = [];
            randoInstanced_1.addWeighted(bonuses, datas.bonusMoney, 2.5);
        }
        createBonusAtTile = function (tx, ty) {
            var cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(tx, ty);
            var bonus = rando.sampleWeighted(bonuses);
            minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, bonus);
        };
        // Create pucks
        // Choose a random spawner
        assert_sidecar_1.assert.notEmpty(puckSpawnerTiles, 'no puck spawners found');
        puckSpawner = rando.sample(puckSpawnerTiles);
        puckSpawner.tileIdxUp = 5;
        createPuckAtTile(puckSpawner.tx, puckSpawner.ty);
        // Create hole (down stairs)
        if (playerState.dungeonLevel === 0) {
            for (i = 0; i < 3; i++) {
                if (holeSpawnerTiles.length < 3) {
                    console.log(crokinoleUi_menu_players_1.namespace, 'reset -- needs three spawners');
                    minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                    return [2 /*return*/, 0];
                }
                holeSpawner = holeSpawnerTiles[i];
                creat = createNextLevelStairsAtTile(holeSpawner.tx, holeSpawner.ty);
                if (i === 0) {
                    creat.state.tag = 'easy';
                }
                if (i === 1) {
                    creat.state.tag = 'normal';
                }
                if (i === 2) {
                    creat.state.tag = 'hard';
                }
            }
        }
        else if (isWinLevel) {
            // No down stairs
        }
        else {
            holeSpawner = rando.sample(holeSpawnerTiles);
            assert_sidecar_1.assert.notEmpty(holeSpawnerTiles, 'no puck spawners found');
            createNextLevelStairsAtTile(holeSpawner.tx, holeSpawner.ty);
        }
        // for (let idxHole = 0; idxHole < holeSpawnerTiles.length; idxHole++) {
        //   let holeSpawner = holeSpawnerTiles[idxHole]
        //   // console.log('spawn hole at', holeSpawner)
        //   createHoleAtTile(holeSpawner.tx, holeSpawner.ty)
        // }
        if (needsAmulet && !isWinLevel) {
            if (bonusSpawnerTiles.length === 0) {
                // Invalid level
                console.log(crokinoleUi_menu_players_1.namespace, 'reset -- needs amulet');
                minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                return [2 /*return*/, 0];
            }
            bonusSpawner = rando.sampleAndRemove(bonusSpawnerTiles);
            cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(bonusSpawner.tx, bonusSpawner.ty);
            minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.bonusAmulet);
        }
        // Create borders
        for (idxBorder = 0; idxBorder < borderTiles.length; idxBorder++) {
            borderSpawner = borderTiles[idxBorder];
            // console.log('spawn border at', borderSpawner)
            createBorderAtTile(borderSpawner.tx, borderSpawner.ty, false, false);
        }
        for (idxBorderH = 0; idxBorderH < borderTilesH.length; idxBorderH++) {
            borderSpawner = borderTilesH[idxBorderH];
            // console.log('spawn border at', borderSpawner)
            createBorderAtTile(borderSpawner.tx, borderSpawner.ty, true, false);
        }
        for (idxBorderV = 0; idxBorderV < borderTilesV.length; idxBorderV++) {
            borderSpawner = borderTilesV[idxBorderV];
            // console.log('spawn border at', borderSpawner)
            createBorderAtTile(borderSpawner.tx, borderSpawner.ty, false, true);
        }
        // Create blocks
        for (idxBlock = 0; idxBlock < blockTiles.length; idxBlock++) {
            blockSpawner = blockTiles[idxBlock];
            // console.log('spawn block at', blockSpawner)
            createCrateAtTile(blockSpawner.tx, blockSpawner.ty);
        }
        // Create triangles
        for (idxTriangle = 0; idxTriangle < triangleSpawnerTiles.length; idxTriangle++) {
            triangleSpawner = triangleSpawnerTiles[idxTriangle];
            // console.log('spawn triangle at', triangleSpawner)
            createTriangleAtTile(triangleSpawner); //.tx, triangleSpawner.ty)
        }
        // Create traps
        for (idxSpawner = 0; idxSpawner < trapSpawnerTiles.length; idxSpawner++) {
            spawner = trapSpawnerTiles[idxSpawner];
            cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(spawner.tx, spawner.ty);
            minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, levelTrapType);
        }
        // TODO:
        // Create slopes
        for (idxSpawner = 0; idxSpawner < slopeSpawnerTiles.length; idxSpawner++) {
            spawner = slopeSpawnerTiles[idxSpawner];
            cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(spawner.tx, spawner.ty);
            creature = minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.slope);
            rot = spawner.rotation + 1;
            creature.rigidBody.setRotation(-mathUtils_sidecar_1.mathUtils.turn(rot / 4), true);
        }
        for (idxSpawner = 0; idxSpawner < slope2SpawnerTiles.length; idxSpawner++) {
            spawner = slope2SpawnerTiles[idxSpawner];
            cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(spawner.tx, spawner.ty);
            creature = minigolfCreatures_sidecar_1.minigolfCreatures.create(cc.x, cc.y, datas.slope2);
            rot = spawner.rotation + 1;
            creature.rigidBody.setRotation(-mathUtils_sidecar_1.mathUtils.turn(rot / 4), true);
        }
        // Create highground
        for (idxSpawner = 0; idxSpawner < highgroundSpawnerTiles.length; idxSpawner++) {
            spawner = highgroundSpawnerTiles[idxSpawner];
            cc = minigolfCamera_sidecar_1.minigolfCamera.tileToPhysics(spawner.tx, spawner.ty);
            // minigolfCreatures.create(cc.x, cc.y, datas.slope)
        }
        if (playerState.isDungeonLocked && !isWinLevel) {
            // Spawn key
            if (bonusSpawnerTiles.length === 0) {
                // Invalid level, no place for key
                minigolfMainGameGenerator_sidecar_1.minigolfMainGameGenerator.signal_newLevel();
                console.log(crokinoleUi_menu_players_1.namespace, 'no place for key');
                return [2 /*return*/, 0];
            }
            bonusSpawner = rando.sampleAndRemove(bonusSpawnerTiles);
            createAtTile(bonusSpawner.tx, bonusSpawner.ty, datas.bonusKey);
        }
        for (idxEnemy = 0; idxEnemy < numEnemyPoints; idxEnemy++) {
            if (bonusSpawnerTiles.length === 0) {
                break;
            }
            if (creaturesList.length === 0) {
                break; // no valid creatures
            }
            bonusSpawner = rando.sampleAndRemove(bonusSpawnerTiles);
            enemy = createEnemyAtTile(bonusSpawner.tx, bonusSpawner.ty);
            idxEnemy += enemy.data.enemyPoints - 1;
        }
        for (idxBonus = 0; idxBonus < numBonuses; idxBonus++) {
            if (bonusSpawnerTiles.length === 0) {
                break;
            }
            bonusSpawner = rando.sampleAndRemove(bonusSpawnerTiles);
            // console.log('spawn bonus at', bonusSpawner)
            createBonusAtTile(bonusSpawner.tx, bonusSpawner.ty);
        }
        return [2 /*return*/];
    });
}
exports.gen_addCreatures = gen_addCreatures;
